import { logger } from "../../utils/logger";

/**
 * Commit a body transform through the store and broadcast UI updates consistently.
 * Always commits position and rotation together to keep baselines coherent.
 * @param {Object} robotActions - Scene actions
 * @param {string} bodyUuid - Body UUID
 * @param {Array} position - [x, y, z] position
 * @param {Array} quaternion - [w, x, y, z] quaternion
 */
export function commitBodyTransform(robotActions, bodyUuid, position, quaternion) {
  if (!robotActions || !bodyUuid) return;
  const posArr = Array.isArray(position) && position.length === 3 ? position : [0, 0, 0];
  const quatArr = Array.isArray(quaternion) && quaternion.length === 4 ? quaternion : [1, 0, 0, 0];

  // Commit to the scene store (UUID only)
  robotActions.setBodyTransform(bodyUuid, posArr, quatArr);

  // Marker updates are driven by tool-specific handlers to ensure correct space (parent-local)

  // Notify listeners for immediate UI feedback (panels, HUD, etc.)
  try {
    const detail = {
      bodyUuid,
      type: "transform",
      position: posArr,
      quaternion: quatArr,
    };
    window.dispatchEvent(
      new CustomEvent("body-transform-updated", {
        detail,
      })
    );
  } catch (error) {
    logger.warn("[commitTransform] Failed to dispatch body-transform-updated event", error);
  }
}
